<template>
  <v-dialog
    max-width="400"
    v-model="closeSafety">
    <v-card
      v-if="closeSafety"
      class="dialog-card">
      <div class="pa-3">
        <ModalHeader
          icon="mdi-alert"
          modalTitle="Are you sure?"
          @close="closeSafety = false" />
      </div>
      <div
        class="mx-3 pa-3"
        style="background: rgba(0, 0, 0, 0.06); border-radius: 5px">
        <v-card-text>
          Are you sure you want to close the OnAir runtime?
        </v-card-text>
      </div>

      <div class="modal-footer">
        <v-btn
          @click="closeSafety = false"
          variant="flat">
          <v-icon class="mr-2">mdi-arrow-left-circle</v-icon>
          back
        </v-btn>
        <v-spacer />
        <v-btn
          @click="(stop_player(), (closeSafety = false))"
          variant="flat"
          dark
          style="background-color: var(--inner-background)">
          <v-icon style="font-size: 22px">check-circle</v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
  <v-card class="pb-4">
    <div class="pa-3">
      <div
        class="queue_name transbackground d-flex align-center justify-space-between"
        style="
          width: 100%;
          display: flex;
          flex-wrap: nowrap;
          color: white;
          border-radius: 5px;
        ">
        <h4
          class="pa-3"
          style="color: white">
          <v-icon
            class="mr-2"
            dark>
            mdi-memory
          </v-icon>
          Hardware
        </h4>
        <v-spacer />
        <v-btn
          variant="text"
          class="mr-1"
          @click="emit('close')">
          <v-icon
            size="large"
            color="white">
            mdi-close-circle
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div
      class="mx-3 pa-3"
      style="
        background: rgba(0, 0, 0, 0.06);
        border-radius: 5px;
        height: 350px;
        overflow-x: hidden;
        overflow-y: auto;
        width: 565px;
      "
      v-if="deluge.hw">
      <div class="pb-4">
        <v-btn
          class="mr-1"
          v-if="'runtime_onair' in deluge"
          :loading="start_load"
          :style="deluge.runtime_onair.online ? '' : 'color:orange'"
          variant="flat"
          small
          @click="
            deluge.runtime_onair.online ? (closeSafety = true) : start_player()
          ">
          <!-- stop_player() -->
          <v-icon class="mr-2">mdi-power</v-icon>
          <div v-if="deluge.runtime_onair.online">Stop Ventuz</div>
          <div v-else>Start Ventuz</div>
        </v-btn>
        <v-btn
          @click="download('download_logs', 'CanvasPro')"
          small
          class="mr-1"
          variant="flat">
          <v-icon class="mr-2">mdi-download</v-icon>
          <div>Logs</div>
        </v-btn>
        <v-btn
          @click="download('download_ventuz_logs', 'Ventuz')"
          small
          variant="flat">
          <v-icon class="mr-2">mdi-download</v-icon>
          <div>Venutz Logs</div>
        </v-btn>
      </div>
      <div v-if="deluge.hw.mem">
        <HWCard
          name="Processor Memory"
          :percent="deluge.hw.mem.virtual_memory.percent"></HWCard>
      </div>
      <div v-if="deluge.hw.gpu">
        <HWCard
          name="Graphics Memory"
          :percent="
            (deluge.hw.gpu['Memory Free (Mib)'] /
              deluge.hw.gpu['Memory Total (Mib)']) *
            100
          "></HWCard>
      </div>
      <div v-if="deluge.hw.gpu">
        <HWCard
          name="Graphics Processing"
          :percent="deluge.hw.gpu['Utilization GPU (%)']"></HWCard>
      </div>
      <div v-if="deluge.hw.gpu">
        <HWCard
          name="Graphics Temperature"
          :percent="deluge.hw.gpu['Temperature GPU'] + ' ℃'"
          :textonly="true"></HWCard>
      </div>
      <div v-if="deluge.hw.network">
        <HWCard
          v-for="int in Object.keys(deluge.hw.network)"
          :key="int"
          :name="int"
          :percent="Math.round(deluge.hw.network[int].in) + ' mb/s'"
          :textonly="true"></HWCard>
      </div>
    </div>
  </v-card>
</template>
<script setup>
import HWCard from './HWCard.vue';
import { ref } from 'vue';
import { deluge } from '@/stores/deluge.js';
import { $http } from '../../stores/http.js';
import ModalHeader from './Modals/ModalHeader.vue';

const closeSafety = ref(false);
const start_load = ref(false);
const stop_load = ref(false);
async function download(url, file_name) {
  try {
    const data = await $http('GET', url);
    var element = document.createElement('a');
    element.setAttribute(
      'href',
      'data:text/plain;charset=utf-8,' + encodeURIComponent(data)
    );
    element.setAttribute(
      'download',
      file_name + ' ' + new Date().toISOString() + '.txt'
    );
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  } catch (error) {
    console.log(error);
  }
}
async function start_player() {
  start_load.value = true;
  try {
    await $http('GET', '/dynamic_engine/start_renderer');
    start_load.value = false;
  } catch (error) {
    console.log(error);
  }
}
async function stop_player() {
  // var r = confirm('Are you sure you want to close the OnAir runtime');
  if (r == true) {
    stop_load.value = true;
    try {
      await $http('GET', '/dynamic_engine/stop_renderer');
      stop_load.value = false;
    } catch (error) {
      console.log(error);
    }
  }
}
</script>
